import { render, staticRenderFns } from "./healPlan.vue?vue&type=template&id=0394ebee&scoped=true&"
import script from "./healPlan.vue?vue&type=script&lang=js&"
export * from "./healPlan.vue?vue&type=script&lang=js&"
import style0 from "./healPlan.vue?vue&type=style&index=0&id=0394ebee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394ebee",
  null
  
)

export default component.exports